import { createAction, props } from '@ngrx/store';
import { gamePlanActive } from '../models/gameplan.model';

/* Getting Header Alert Active Game plan */
export const loadGamePlan = createAction('[GamePlan] Load Users', props<{ payload: { [key: string]: any } }>()); //Post method
export const loadGamePlanSuccess = createAction('[GamePlan] Load Users Success', props<{ gamePlanActive: gamePlanActive[] }>());
export const loadGamePlanFailure = createAction('[GamePlan] Load Users Failure', props<{ error: any }>());


export const loadGamePlanJourney = createAction('[GamePlan] Load Journey');
export const loadGamePlanJourneySuccess = createAction('[GamePlan] Load Journey Success', props<{ journeyData: any[] }>());
export const loadGamePlanJourneyFailure = createAction('[GamePlan] Load Journey Failure', props<{ error: any }>());


